import { useParams } from "react-router-dom";

import { useQuery } from "@apollo/client";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes/absoluteRoutes";
import { type MyLensesAdAccount } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { getAdAccounts } from "../api/queries/getAdAccountIds";
import {
    type GetAdAccountsQuery,
    type GetAdAccountsQueryVariables,
} from "../api/queries/getAdAccountIds.gql-generated";

export const useAdAccounts = (): ApolloResult<{ orgId?: string; adAccounts: readonly MyLensesAdAccount[] }> => {
    const { orgId } = useParams<RouteParams[AbsoluteRoute.ORG]>();
    const { data, loading, error } = useQuery<GetAdAccountsQuery, GetAdAccountsQueryVariables>(getAdAccounts, {
        skip: !orgId,
        variables: {
            organizationId: orgId ?? "",
            limit: 1,
        },
    });

    const adAccounts = data?.getMyLensesAdAccounts.adAccounts ?? [];

    return {
        adAccounts,
        orgId,
        loading,
        error,
    };
};
